import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetHolidays(params) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/holidays`,
        params: params || {},
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestAddHoliday(date, name, description) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/holidays`,
        data: { date, name, description },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestEditHoliday(id, date, name, description) {
    return axios.request({
        method: "put",
        url: `${getApiUrl()}/holidays/${id}`,
        data: { date, name, description },
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteHoliday(id) {
    return axios.request({
        method: "delete",
        url: `${getApiUrl()}/holidays/${id}`,
        withCredentials: true,
        crossorigin: true,
    });
}
